import type { ResultOf } from '@graphql-typed-document-node/core'
import { money } from '~/lib/money/money'
import type { Coupon } from './Coupon.frag'

export function calcMaxOffPrice(coupons: readonly ResultOf<typeof Coupon>[]): string {
  return money(Math.max(...coupons.map((coupon) => coupon.discountAmount)))
}
